/**
 * Get the value of the cover toggle
 * A Select input will return its selected value. For Checkboxes,
 * truthy values can be a number, cast as a string, or "yes";
 * falsy values can be "0", for the former, or "no"
 */
type GetCoverToggleProps = {
  inputType: string; // match e.target.type
  checked?: boolean;
  value: string;
  toggleOnValue?: string;
  toggleOffValue?: string;
};

export const getCoverToggleValue = ({
  inputType,
  checked,
  value,
  toggleOnValue = "",
  toggleOffValue = "",
}: GetCoverToggleProps): string => {
  if (inputType === "checkbox") {
    return checked ? toggleOnValue : toggleOffValue;
  }
  // Catch any other type, including select
  return value;
};
